import RegisterBanner from "../../components/banners/RegisterBanner";
import RegisterForm from "./RegisterForm";

export default function Register() {
  return (
    <div>
      <RegisterBanner />
      <RegisterForm />
    </div>
  );
}
